import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const siteApi = createApi({
  reducerPath: 'siteApi',
  baseQuery: fetchBaseQuery({ baseUrl: 'https://panel.linket.me/api/site' }),
  tagTypes: ['Setting'],

  endpoints: (builder) => ({
    getSetting: builder.query({
      query: () => `/getSite`,
    }),
  }),
})

export const { useGetSettingQuery } = siteApi